import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { LoadMoreButton, ShevronDownIcon } from './styles';
const LoadMore = ({ hasMore, loadMore, text = '', children, className = '', prependIcon = null, appendIcon = React.createElement(ShevronDownIcon, null), isExpanded = true, }) => {
    const [expanded, setExpanded] = useState(isExpanded);
    useEffect(() => setExpanded(isExpanded), [isExpanded]);
    if (expanded) {
        return (React.createElement("div", null,
            children,
            hasMore && (React.createElement(LoadMoreButton, { className: className, onClick: loadMore },
                prependIcon,
                " ",
                text || React.createElement(FormattedMessage, { id: "loadMore" }),
                " ",
                appendIcon))));
    }
    return !!children.length ? (React.createElement("div", null,
        React.createElement(LoadMoreButton, { className: className, onClick: () => setExpanded(true) },
            prependIcon,
            " ",
            text || React.createElement(FormattedMessage, { id: "loadMore" }),
            " ",
            appendIcon))) : null;
};
export default LoadMore;
//# sourceMappingURL=index.js.map